export const encryptionSecretKey = 'zjGSocXnFyatOHOIiYtrBXD7dhYVPGc9Rhn'
export const superAdminName = 'revalgo'
export const superAdminDomainName = 'revalgo.ai'
export const appRoles = {
  Superadmin: 'Superadmin',
  TenantAdmin: 'TenantAdmin',
  Salesperson: 'Salesperson',
  CompanyAdmin: 'CompanyAdmin'
}
